module.exports = __webpack_public_path__ + "assets/img/files-received.746ab263.svg";